export default class Geolocalizer {
    constructor() {
        this.maximumAge = 5000;
        this.timeout = 5000;
        this.enableHighAccuracy = true;
    }

    localize(onSuccessCallback, onErrorCallback) {
        navigator.geolocation.getCurrentPosition(
            function onSuccess(position) {
                if (typeof(onSuccessCallback) === 'function') { onSuccessCallback(position); }
            },

            function onError(error) {
                if (typeof(onErrorCallback) === 'function') { onErrorCallback(error); }

                console.log('Position error, code: '    + error.code    + '\n' +
                    'message: ' + error.message + '\n');
            }, { maximumAge: this.maximumAge, timeout: this.timeout, enableHighAccuracy: this.enableHighAccuracy });
    }

    static isSupported() {
        return typeof(navigator.geolocation) === 'object';
    }
}